import { Button, Heading, PageContainer } from "@/components/ui";

/** Shown when the offer is outside its serving hours; the only action returns to the menu. */
export function ItemUnavailableState({ onClose }: { onClose: () => void }) {
  return (
    <PageContainer className="flex min-h-empty flex-col items-center justify-center gap-8">
      <Heading level={1} size="page" tone="muted" align="center">
        Este produto não está disponível neste horário.
      </Heading>
      <Button size="lg" fullWidth onClick={onClose} className="max-w-md">
        Voltar ao cardápio
      </Button>
    </PageContainer>
  );
}
